"use strict";
// @ts-ignore
try {
    self['workbox:cacheable-response:7.2.0'] && _();
}
catch (e) { }
